export default function RulesPage() {
  return (
    <>
      <h1>Rules</h1>
      <div className="card">
        <p>
          The leaderboard is ranked by teams remaining first. Ties are broken by
          aggregate goal difference, then goals scored, then official tournament
          points.
        </p>
        <p>No custom scoring is used.</p>
        <p>
          A team counts as remaining until it can no longer reach the knockout
          stage. During the group stage we only drop a team once it is
          mathematically impossible for it to finish in the top two of its group
          or as one of the eight best third-placed teams — so a team is never
          removed while it still has any path through. In knockout matches, the
          losing team is eliminated once the match is finished.
        </p>
        <p>Times are shown in your local timezone.</p>
      </div>

      <h2 className="section">Default sort</h2>
      <div className="card">
        <ol>
          <li>Teams remaining ↓</li>
          <li>Goal difference ↓</li>
          <li>Goals for ↓</li>
          <li>Points ↓</li>
          <li>Person A–Z</li>
        </ol>
      </div>
    </>
  );
}
